import React, {useEffect, useState} from 'react';
import { Card, Button, Divider, Tag} from 'antd';
import pluginJumbo from './plugin.svg'
import installGuide from './install.jpg'
import upgradeGuide from './upgrade.jpg'
import pluginZip from './damai-extension.jpg'
import upgradeLog from './upgrade-log.jpg'
import {DownloadOutlined} from '@ant-design/icons';

const extensionBinaryUrl = 'https://ml-extension-dist-1258148724.cos.ap-guangzhou.myqcloud.com/damai-extension_latest_.zip'

const AjaxToDom = ({url}) => {
    const [data, setData] = useState('')
    useEffect(()=> {
        fetch(url)
            .then(d => d.text())
            .then(d => setData(d))
    }, [url, setData])

    return <span>{data}</span>
}


export const PluginDetailInfoTitle= () => {
    return <div className='tw-flex tw-items-center tw-flex-col'>
        <img src={pluginJumbo} className='tw-my-8'/>
        <div className='tw-flex tw-items-center'>
            <span className='tw-text-4xl tw-my-4'>DM插件</span>
            <span className='tw-ml-2'><Tag color='#FA541C'>v1.17</Tag></span>
            {/*<span className='tw-ml-2'><Tag color='#FA541C'>v
                <AjaxToDom url='/nodeapi/constants/app-version'/>
            </Tag></span>*/}
        </div>
        <div>一键点击，快速获得竞品数据，提升选品和运营效率达5倍以上。</div>
    </div>
}

export const PluginDetailInfoDownload = () => {
    return (<span className='tw-flex tw-items-center tw-justify-center'>
            <Button type="primary" className='tw-my-4 ' size='large'>
                <a href={extensionBinaryUrl} download='damai-extension.zip'>
                    免费获取最新插件!
                </a>
            </Button>
            <div className='tw-absolute tw-left-[calc(50%+105px)]'>
                <a className='tw-mr-2' href={installGuide} download="大麦插件安装.rtf"> 安装说明</a>
                <a className='tw-mr-2' href={upgradeGuide} download="大麦插件升级说明.rtf"> 升级说明</a>
                <a href={upgradeLog} download="更新日志.txt"> 更新日志</a>
            </div>
        </span>)

}

export const PluginDetailInfo = () => {
    return <div className='tw-flex tw-flex-col tw-items-center '>
        <PluginDetailInfoTitle/>
        <PluginDetailInfoDownload/>
    </div>}
